export const bannerTypes = {
  market: 'MARKET',
  alert: 'ALERT',
  info: 'INFO',
}
